import {DialogContent, DialogTitle, IconButton, Typography} from '@mui/material'
import React, {ReactNode} from 'react'
import {sx} from './sx'
import CloseIcon from '@mui/icons-material/Close'
import DraggableCustom from '@ui/draggle/DraggableCustom'


interface IProps {
	title?: string | ReactNode,
	children: ReactNode,
	open: boolean,
	onClose: () => void
}

export default function DraggableModalWithoutPortal({
														title,
														children,
														open,
														onClose,
													}: IProps) {


	const handleClose = () => {
		onClose()
	}

	return (
		<>
			{open && <DraggableCustom
                moveComponent={<DialogTitle
					sx={sx.title}
					id="draggable-dialog-title"
				>
					<Typography component={'span'} sx={sx.label}>
						{title && title}
					</Typography>

					<IconButton
						size={'small'}
						sx={sx.closeIcon}
						onClick={handleClose}
						onMouseDown={(e) => e.stopPropagation()}
						aria-label={'close'}
					>
						<CloseIcon fontSize={'small'}/>
					</IconButton>
				</DialogTitle>}
            >

                <DialogContent
                    className={'rootContentDraggableModal'}
                    sx={sx.content}
                >
					{children}
                </DialogContent>
            </DraggableCustom>}
		</>
	)

}
